import{jsx as r}from"react/jsx-runtime";import{c as a}from"./createSvgIcon-7d989ad9.js";var o=a(r("path",{d:"M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"}),"ExpandMore");export{o as E};
